import React from 'react'
import Children from 'react-children-utilities'

import slugify from 'slugify'

import style from './HtmlHeader.module.scss'

const H1 = ({
  children
}) => (
  <h1 className={style.plainHeader}>
    <span>{ children }</span>
  </h1>
)

const H2 = ({
  children
}) => {
  const id = slugify(Children.onlyText(children))
  const anchor = `#${id}`

  return (
    <h2 id={id} className={style.header}>
      <a href={ anchor }>{ children }</a>
    </h2>
  )
}

const H3 = ({
  children
}) => {
  const id = slugify(Children.onlyText(children))
  const anchor = `#${id}`

  return (
    <h3 id={id} className={style.header}>
      <a href={ anchor }>{ children }</a>
    </h3>
  )
}

const H4 = ({
  children
}) => {
  const id = slugify(Children.onlyText(children))
  const anchor = `#${id}`

  return (
    <h4 id={id} className={style.header}>
      <a href={ anchor }>{ children }</a>
    </h4>
  )
}

const H5 = ({
  children
}) => {
  const id = slugify(Children.onlyText(children))
  const anchor = `#${id}`

  return (
    <h5 id={id} className={style.header}>
      <a href={ anchor }>{ children }</a>
    </h5>
  )
}

const H6 = ({
  children
}) => {
  const id = slugify(Children.onlyText(children))
  const anchor = `#${id}`

  return (
    <h6 id={id} className={style.header}>
      <a href={ anchor }>{ children }</a>
    </h6>
  )
}

export {
  H1,
  H2,
  H3,
  H4,
  H5,
  H6
}